<template>
    <div class="page box has-background-white-biys  has-text-dark">
        <div class="tabs pt-5" id="tabs">
            <ul>
                <li :class="[curr_tab == 'liste' ? 'is-active' : '']">
                    <router-link to="/equipesmobiles/liste">Les EMPSA en IdF</router-link>
                </li>
                <li :class="[curr_tab == 'rechercher' ? 'is-active' : '']">
                    <router-link to="/equipesmobiles/rechercher">Chercher une EMPSA</router-link>
                </li>
                <li :class="[curr_tab == 'fiche' ? 'is-active' : '']">
                    <router-link :to="'/equipesmobiles/fiche/'+curr_equipe">Présentation des équipes</router-link>
                </li>
            </ul>
        </div>
        <div v-if="loading" class="loading">
            Loading...
        </div>
        <div v-if="error" class="notifications is-lightx">
            <NotFound />
        </div>
        <div v-if="curr_tab == 'liste'" class="content px-5 py-5">
            <div v-if="equipes">
                <p>Les équipes mobiles de Psychiatrie du sujet âgé se développent en Ile-de-France depuis quelques années afin de répondre à la difficulté d’accès aux soins, liée au manque de mobilité des personnes, à leur isolement, leur fragilité et au risque de situations de rupture.<br><br>
Le maintien au domicile étant un enjeu de santé publique, il est nécessaire « d’aller vers » pour mieux coordonner le parcours de soins de la personne.
<br><br>Les missions des EMPSA s’articulent autour de 3 principaux axes : évaluer, orienter et coordonner.
<br><br>Les équipes mobiles ont aussi un rôle d’acculturation au soin psychique et de formation des équipes avec lesquelles elles collaborent dans le champ de la psychiatrie du sujet âgé.</p>
                <h4 class="title is-5 pt-4">Répartition en IDF</h4>
                <figure class="image is-4by3">
                    <iframe class="has-ratio" width="100%" height="300px" frameborder="0" allowfullscreen src="//umap.openstreetmap.fr/fr/map/equipes-mobiles_627383?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&allowEdit=false&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=undefined&captionBar=false"></iframe>
                </figure>
                <h4 class="title is-5 pt-2 is-hidden">Liste des équipes mobiles</h4>
                <div class="table-container">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Equipe</th>
                                <th>Hôpital de rattachement</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="equipe in equipes" v-bind:key="equipe._id">
                                <td>{{equipe.title}}
                                    <span class="tag is-warning is-hidden" v-for="se in equipe.secteur" v-bind:key="se._id">{{se}}</span>
                                </td>
                                <td><span v-if="equipe.hopitalrattachement">{{equipe.hopitalrattachement.toUpperCase()}}</span></td>
                                <td>
                                    <b-button tag="router-link" :to="'/'+equipe.slug+'#tabs'" type="is-primary" size="is-small" outlinedx rounded>
                                        + infos
                                    </b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-if="curr_tab == 'rechercher'" class="content px-5 py-5">
            <h4 class="title is-5">Chercher une EMPSA</h4>
            <p class="pt-2">Entrer le nom d'une ville ou un code postal :</p>
            <p align="center">
                <b-field>
                    <b-input v-on:keyup.native.enter="searchEM" placeholder="Chercher..." type="search" icon="magnify" size="is-medium" v-model="searchQuery" expanded>
                    </b-input>
                    <p class="control">
                        <b-button type="is-primary" label="Valider" size="is-medium" v-on:click="searchEM" />
                    </p>
                </b-field>
            </p>
            <p class="notification" v-if="searchInit">
                <template v-if="!!searchResult">Equipe(s) trouvée(s) :<br><br>
                    <div class="has-text-right py-1" v-for="searchResultEquipe in searchResultEquipes" v-bind:key="searchResultEquipe._id">
                        {{searchResultEquipe.title}}<span v-if="searchResultEquipe.hopitalrattachement"> (rattachement : {{searchResultEquipe.hopitalrattachement.toUpperCase()}})</span>
                        <b-button tag="router-link" :to="'/'+searchResultEquipe.slug" type="is-primary" size="is-small" class="mx-6" rounded>+ infos</b-button>
                    </div>
                    <p class="notification is-warningx pt-6 is-italic" v-if="searchResultMult"><b>Attention :</b> votre recherche a donné plusieurs résultats. Pour une recherche plus précise, veuillez entrer un code postal.</p>
                </template>
                <template v-else>Il n’y a pas d'EMPSA intervenant sur cette commune</template>
            </p>
        </div>
        <div v-if="curr_equipe !== 'null' && curr_tab == 'fiche'" class="content px-5 py-5">
            <div v-for="equipe in equipes" v-bind:key="equipe._id">
                <div v-if="equipe.slug == 'equipesmobiles/fiche/'+curr_equipe">
                    <h4>{{equipe.title}}</h4>
                    <div v-html="equipe.content"></div>
                </div>
            </div>
        </div>
        <div v-if="curr_equipe == 'null' && curr_tab == 'fiche'" class="content px-5 py-5">
            <i>Veuillez choisir une équipe dans les onglets précédents</i>
        </div>
    </div>
</template>
<script>
const axios = require('axios');
import NotFound from './NotFound.vue'


function sansAccent(str){
    var accent = [
        /[\300-\306]/g, /[\340-\346]/g, // A, a
        /[\310-\313]/g, /[\350-\353]/g, // E, e
        /[\314-\317]/g, /[\354-\357]/g, // I, i
        /[\322-\330]/g, /[\362-\370]/g, // O, o
        /[\331-\334]/g, /[\371-\374]/g, // U, u
        /[\321]/g, /[\361]/g, // N, n
        /[\307]/g, /[\347]/g, // C, c
    ];
    var noaccent = ['A','a','E','e','I','i','O','o','U','u','N','n','C','c'];

    //str = this;
    for(var i = 0; i < accent.length; i++){
        str = str.replace(accent[i], noaccent[i]);
    }

    return str;
}


export default {
    data: function() {
        return {
            loading: true,
            error: null,
            curr_tab: null,
            curr_equipe: null,
            maintitle: 'Equipes Mobiles',
            equipes: null,
            searchQuery: null,
            searchResult: false,
            searchResultMult: false,
            searchInit: false,
            geodata: null
        }
    },
    name: 'EquipesMobiles',
    components: {
        NotFound
    },

    created() {
        this.fetchData()
        this.curr_tab = this.$route.params.tab ?? 'liste'
        this.curr_equipe = this.$route.params.equipe ?? this.curr_equipe
    },
    updated() {
        this.curr_tab = this.$route.params.tab ?? 'liste'
        this.curr_equipe = this.$route.params.equipe ?? this.curr_equipe
        this.maintitle = this.page ? this.page.title : this.maintitle
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            this.error = this.page = null
            this.loading = true
            var vm = this
            //var fetchurl = this.$api_url_emobiles
            var fetchurl = this.$api_url_emobiles+'&sort[title]=1&filter[active]=true&populate=1'
            axios({
                    method: 'get',
                    url: fetchurl,
                    /*headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        //filter: { slug: slug },
                        //limit: 1,
                        sort: { title: 1 },
                        populate: 1, // resolve linked collection items
                        lang: 'fr' // return normalized language fields (fieldA_de => fieldA)
                    })*/
                }).then(function(response) {
                    vm.loading = false
                    if (response.data.entries.length > 0) {
                        vm.equipes = response.data.entries
                        vm.error = null
                    } else {
                        vm.equipes = null
                        vm.error = 'page introuvable'
                        vm.$router.push({ name: '404' })

                    }
                })
                .catch(function() {
                    //console.log("Erreur ! Impossible d'accéder à l'API." + error)
                    vm.error = 'page introuvable'
                    vm.$router.push({ name: '404' })
                })

        },

        searchEM: function() {
            var minchars = 2
            var re = /-/gi
            var qsearch = this.searchQuery ? this.searchQuery.trim() : null
            if (this.searchQuery && (qsearch.length > minchars - 1)) {
                this.searchInit = true
                this.searchResult = false
                this.searchResultEquipes = []

                var qsearch_format = qsearch.replace(re, ' ').toLowerCase()
                qsearch_format = sansAccent(qsearch_format)

                for (var i = this.equipes.length - 1; i >= 0; i--) {
                    var secteur = this.equipes[i].secteur
                    var secteur_format = secteur.replace(re, ' ').toLowerCase()
                    secteur_format = sansAccent(secteur_format)
                    //console.log(secteur_format)
                    if (secteur && secteur_format.includes(qsearch_format)){
                        this.searchResultEquipes.push(this.equipes[i])
                        //this.searchResultSecteurs.push(secteur)
                    }
                }
                this.searchResult = this.searchResultEquipes.length > 0
                this.searchResultMult = this.searchResultEquipes.length > 1
            } else {
                alert('Veuillez indiquer au moins ' + minchars + ' caractères pour lancer la recherche')
            }

        }

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
    min-height: 300px;
    margin-bottom: 100px;
    margin-top: 100px;
}

.box {
    border-radius: 0px;
    border-left: 12px solid #ff3860;
    box-shadow: 1px 1px 12px #555;
}

li.is-activew {
    font-weight: bold;
}

li a {
    font-size: 14pt;

}

li.is-active a {
    border-bottom-color: #ff3860 !important;
    color: white !important;
    background: #ff3860;
}

iframe {
    height: 500px;
}

.content figure {
    margin-left: 0em;
    margin-right: 0em;
}


@media only screen and (max-width: 600px) {
    .page {
        margin-bottom: 50px;
        margin-top: 50px;
    }
}
</style>